import Intro from './components/intro/Intro';
import About from './components/about/About';
import ProductList from './components/productList/ProductList';
import Contact from './components/contact/Contact';
import Toggle from './components/toggle/Toggle';
import HamburgerMenu from './components/hamburgerMenu/hamburgerMenu';
import { useContext } from 'react';
import { ThemeContext } from './context';
import Skills from './components/skills/skills';

const App = () => {
  const theme = useContext(ThemeContext);
  const darkMode = theme.state.darkMode;

  return (
    <div className="app" style={{ backgroundColor: darkMode ? '#222' : 'white', color: darkMode ? 'white' : '#222' }}>
      <HamburgerMenu />
      <Toggle />
      <main>
        <section id="home"><Intro /></section>
        <section id="about"><About /></section>
        <section id="skills"><Skills /></section>
        <section id="projects"><ProductList /></section>
        <section id="contact"><Contact /></section>
      </main>
    </div>
  );
};

export default App;
